import {gql} from '@apollo/client'

export const GET_ALL_CONTACTS_API = gql`
  query GetAllContactsAPI(
    $offset: Int
    $first: Int
    $name: String
    $status: String
    $policyStatus: String
    $policyType: String
    $state: String
    $carrier: String
    $birthMonth: String
    $ageFrom: String
    $ageTo: String
    $policyCreatedFrom: Date
    $policyCreatedTo: Date
    $submissionDateFrom: Date
    $submissionDateTo: Date
    $completedDateFrom: Date
    $completedDateTo: Date
    $lead: String
    $isRecipient: Boolean
    $segment: String
    $organization: String
  ) {
    allContacts(
      offset: $offset
      first: $first
      name: $name
      status: $status
      policyStatus: $policyStatus
      policyType: $policyType
      state: $state
      carrier: $carrier
      birthMonth: $birthMonth
      ageFrom: $ageFrom
      ageTo: $ageTo
      policyCreatedFrom: $policyCreatedFrom
      policyCreatedTo: $policyCreatedTo
      submissionDateFrom: $submissionDateFrom
      submissionDateTo: $submissionDateTo
      completedDateFrom: $completedDateFrom
      completedDateTo: $completedDateTo
      lead: $lead
      isRecipient: $isRecipient
      segment: $segment
      organization: $organization
    ) {
      totalCount
      pageInfo {
        hasNextPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          fullName
          firstName
          lastName
          email
          phone
          dateBirth
          created
          isImportant
          subscriptionStatus
          tagAssignments {
            tag {
              id
              name
              color
            }
          }
          memberPolicy {
            id
          }
          signatureEntries {
            edges {
              node {
                id
                signedOn
                requestedOn
                status
              }
            }
          }
        }
      }
    }
  }
`

export const GET_ALL_RECIPIENTS = gql`
  query GetAllRecipients(
    $offset: Int
    $first: Int
    $name: String
    $subscriptionStatus: String
    $policyStatus: String
    $policyType: String
    $state: String
    $carrier: String
    $policyCreatedFrom: Date
    $policyCreatedTo: Date
    $submissionDateFrom: Date
    $submissionDateTo: Date
    $completedDateFrom: Date
    $completedDateTo: Date
    $lead: String
    $segment: String
  ) {
    allRecipients(
      offset: $offset
      first: $first
      name: $name
      subscriptionStatus: $subscriptionStatus
      policyStatus: $policyStatus
      policyType: $policyType
      state: $state
      carrier: $carrier
      policyCreatedFrom: $policyCreatedFrom
      policyCreatedTo: $policyCreatedTo
      submissionDateFrom: $submissionDateFrom
      submissionDateTo: $submissionDateTo
      completedDateFrom: $completedDateFrom
      completedDateTo: $completedDateTo
      lead: $lead
      segment: $segment
    ) {
      totalCount
      pageInfo {
        hasNextPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          fullName
          firstName
          lastName
          email
          phone
          dateBirth
          created
          isImportant
          subscriptionStatus
          tagAssignments {
            tag {
              id
              name
              color
            }
          }
          memberPolicy {
            id
          }
          signatureEntries {
            edges {
              node {
                id
                signedOn
                requestedOn
                status
              }
            }
          }
        }
      }
    }
    recipientStats {
      totalRecipients
      subscribedCount
      unsubscribedCount
    }
  }
`

export const GET_ONE_CONTACT_API = gql`
  query contactById($id: String!) {
    contactById(id: $id) {
      id
      fullName
      firstName
      lastName
      middleName
      secondLastName
      preferredLenguage
      dateBirth
      gender
      email
      phone
      address1
      address2
      city
      zipCode
      countyFips
      stateEU {
        id
        name
      }
      memberPolicy {
        id
        rol
      }
      members {
        edges {
          node {
            id
            rol
          }
        }
      }
      user {
        id
        firstName
        lastName
      }
      created
      updated
    }
  }
`

export const GET_ALL_CONTACTS_PREVIEW = gql`
  query allContactsPreview(
    $name: String, 
  ) {
    allContactsPreview(    
      name: $name
    ) {
      edges {
        node {
          id
          fullName
          firstName
          middleName
          lastName
          secondLastName
          preferredLenguage
          phone
          dateBirth
          gender
          email
          address1
          address2
          city
          zipCode
          immigrationStatus
          stateEU {
            id
            name
          }
          memberPolicy {
            id
            rol
            policy {
              id
              status
              paymentStatus
              type
              policyName
              created
              completedDate
              carrier {
                id
                name
              }
              typePolicy {
                id
                typePolicy
              }
              user {
                id
                firstName
                lastName
              }
              assignedTo {
                id
                firstName
                lastName
              }
              effectiveDate
            }
          }
          members {
            edges {
              node {
                id
                rol
                policy {
                  id
                  status
                  paymentStatus
                  type
                  policyName
                  created
                  completedDate
                  carrier {
                    id
                    name
                  }
                  typePolicy {
                    id
                    typePolicy
                  }
                  user {
                    id
                    firstName
                    lastName
                  }
                  assignedTo {
                    id
                    firstName
                    lastName
                  }
                  effectiveDate
                }
              }
            }
          }
        }
      }
    }
  }
`

export const GET_CONTACT_COMMUNICATION_LOGS = gql`
  query allCommunications($originModule: String, $originId: String, $contactId: String) {
    allCommunications(first: 50, originModule: $originModule, originId: $originId, contact: $contactId) {
      edges {
        node {
          id
          channel
          direction
          status
          content
          metadata
          created
          user {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
`
